import React, { useState } from 'react';
import { BASE_URL } from '../config/api';
import { useNavigate } from 'react-router-dom';

const AddLeads = () => {
    const [name, setName] = useState('');
    const [number, setNumber] = useState('');
    const [followupDate, setFollowupDate] = useState('');
    const [description, setDescription] = useState('');
    const [status, setStatus] = useState('pending');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const payload = {
            staff_id: 1, // Adjust staff_id dynamically as needed
            name,
            number,
            followup_date: followupDate,
            description,
            status,
        };

        fetch(`${BASE_URL}leads`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                setIsSubmitting(false);
                if (data.status === 1) {
                    alert('Lead created successfully!');
                    navigate('/LeadsList'); // Redirect to LeadsList after successful creation
                } else {
                    alert('Failed to create lead. Please try again.');
                }
            })
            .catch(error => {
                setIsSubmitting(false);
                console.error('Error creating lead:', error);
                alert('An error occurred. Please try again.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Sales Lead</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label>Number</label>
                               <input
    type="text"
    className="form-control"
    value={number}
    onChange={(e) => {
        // Only allow digits (0-9) and limit to 10 digits
        const newValue = e.target.value.replace(/\D/g, '').slice(0, 10); // Remove non-digits and limit length to 10
        setNumber(newValue);
    }}
    required
    placeholder="Enter 10 digit number"
/>

                            </div>

                            <div className="form-group">
                                <label>Follow-Up Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={followupDate}
                                    onChange={(e) => setFollowupDate(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label>Description</label>
                                <textarea
                                    className="form-control"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    required
                                ></textarea>
                            </div>

                            <div className="form-group">
                                <label>Status</label>
                                <select
                                    className="form-control"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                >
                                    <option value="pending">Pending</option>
                                    <option value="completed">Completed</option>
                                </select>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Submitting...' : 'Add Lead'}
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddLeads;
